import { useScreenSize } from '@hooks';
import helmet from '@pngs/AboutUsPage/helmet.png';
import Net from '@pngs/NetVertical.png';
import { Flex } from '@styles';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { aboutUsLayoutByVariant } from '../../AboutUsPage.layoutProps';
import TextWithPic from '../TextWithPic/TextWithPic';

const OurMissionVision = () => {
  const { i18n } = useTranslation();
  const { device, isLaptop, isTabletLG, isTabletSM } = useScreenSize();
  const layout = aboutUsLayoutByVariant[device];

  return (
    <Flex flexDirection="column" position="relative">
      <Flex
        backgroundImage={Net}
        backgroundRepeat="no-repeat"
        backgroundSize="cover"
        height="1200px"
        position="absolute"
        right="23px"
        top="13px"
        width="624px"
      />
      <Flex
        border="0.5px solid rgb(255, 255, 255, 0.3)"
        maxWidth={isTabletLG ? '100%' : '60%'}
        px={layout}
        py={isTabletLG ? 0 : '5%'}
      >
        <TextWithPic
          description={i18n.t('AboutUs.Mission.Description')}
          isTablet={isTabletLG}
          left
          title={i18n.t('AboutUs.Mission.Title')}
        />
      </Flex>
      <TextWithPic
        description={i18n.t('AboutUs.Vision.Description')}
        imageStyle={{
          borderBottom: isTabletLG && `1px solid rgb(255, 255, 255, 0.3)`,
          flexShrink: isLaptop ? 0 : 1,
          ...(isLaptop && { height: '50%', width: '50%' }),
          ...(isTabletSM && { height: '55%', width: '55%' }),
        }}
        isTablet={isTabletLG}
        left
        src={helmet}
        style={{
          ...(isTabletSM && { alignItems: 'flex-start' }),
          borderTop: `1px solid rgb(255, 255, 255, 0.3)`,
          flexDirection: isTabletSM ? 'column' : 'row',
          pr: layout,
        }}
        title={i18n.t('AboutUs.Vision.Title')}
      />
    </Flex>
  );
};

export default OurMissionVision;
